// Seller Sourcing History routes (pure constants: imported by the shop header config too).
// One /seller/provider-history namespace, next to the other Seller-side Provider routes
// (/seller/providers, /seller/provider-catalog, /seller/provider-products ...). Distinct from the
// Royalty retail history pages (/user-viewed, /search-history), which are not touched.
export const SELLER_HISTORY_ROUTES = Object.freeze({
  providers: "/seller/provider-history/providers",
  products: "/seller/provider-history/products",
});

// Server-side caps (providerEngagementService.js); shown in the page counters.
export const SELLER_HISTORY_MAX = Object.freeze({ providers: 15, products: 30 });
